module.exports = __webpack_public_path__ + "cement/img/图像 293@2x.424dc2e4.png";